import React, {Component} from 'react';
import "./Copyright.css";

class Copyright extends Component {
	render() {
		return (
			<div className={"copyright"}>
				<span>&#169; SAR, LLC {new Date().getFullYear()}</span>
			</div>
		);
	}
}


export default Copyright;



// WEBPACK FOOTER //
// ./src/components/Copyright/Copyright.js